import React, { useState } from 'react';


const ExpandableText = ({  maxChars = 60, producto }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const text = producto?.descripcion;

  if (!text || text.length === 0) {
    return <p>No hay texto disponible</p>;
  }

  const truncatedText = text.slice(0, maxChars);
  const shouldTruncate = text.length > maxChars;

  return (
    <div>
      <p style={{ margin: 0, color: 'white' }}>
          {text}
      </p>
     
      {shouldTruncate && (
        <button
          onClick={toggleExpand}
          style={{
            background: 'none',
            border: 'none',
            color: 'slateblue',
            cursor: 'pointer',
            padding: '4px 0',
            fontSize: '0.9em',
            outline: 'none',
          }}
          aria-expanded={isExpanded}
          aria-controls="expandable-text"
        >
         
        </button>
      )}
    </div>
  );
};

export default ExpandableText;

